import {
  GET_BANK_DETAILS,
  GET_BANK_DETAILS_FOR_USER,
  SET_BANK_DETAILS,
  SET_BANK_DETAILS_FOR_USER,
  UPDATE_BANK_DETAILS,
  DELETE_BANK_DETAILS,
  BANK_DETAILS_LOADING,
  ADD_BANK_DETAILS,
} from "./actionTypes";

export const getBankDetails = () => ({
  type: GET_BANK_DETAILS,
});

export const setBankDetails = data => ({
  type: SET_BANK_DETAILS,
  payload: data,
});

export const getBankDetailsForUser = id => ({
  type: GET_BANK_DETAILS_FOR_USER,
  payload: id,
});

export const setBankDetailsForUser = data => ({
  type: SET_BANK_DETAILS_FOR_USER,
  payload: data,
});

export const addBankDetails = (data) => ({
  type: ADD_BANK_DETAILS,
  payload: data,
});

export const updateBankDetails = (id, data, user) => ({
  type: UPDATE_BANK_DETAILS,
  payload: { id, data, user },
});

export const deleteBankDetails = (id, user) => ({
  type: DELETE_BANK_DETAILS,
  payload: { id, user },
});

export const bankDetailsLoading = () => ({
  type: BANK_DETAILS_LOADING,
});
